import { transparentize } from "polished";
import styled, { DefaultTheme } from "styled-components";
import type { BadgeColor } from "./Badge";

interface BadgeCtnProps {
  $color?: BadgeColor;
}

const statusTone = (color: string) => `
  background-color: ${transparentize(0.85, color)};
  border-color: ${transparentize(0.5, color)};
`;

const toneStyles = (theme: DefaultTheme, color?: BadgeColor) => {
  switch (color) {
    case "crimson":
      return `
        background-color: ${theme.warningBg};
        color: ${theme.warningText};
        border-color: ${theme.warningBorder};
      `;
    case "success":
      return statusTone(theme.success);
    case "pending":
      return statusTone(theme.pending);
    case "danger":
      return statusTone(theme.cancel);
    default:
      return "";
  }
};

export const BadgeCtn = styled.div<BadgeCtnProps>`
  display: flex;
  align-items: baseline;
  border: 1px solid ${(props) => props.theme.lightgrey};
  background-color: ${(props) => props.theme.lightgrey};
  border-radius: 16px;
  padding: 2px 6px;

  ${({ $color, theme }) => toneStyles(theme, $color)};
`;
